import React from 'react';
import ComparisonRatingChart from '@components/charts/ComparisonRatingChart';
import ComparisonAverageScoreTable from './ComparisonAverageScoreTable';
import type { ComparisonCardData } from '@app-types/comparison';
import './ComparisonCard.less';

export interface ComparisonCardProps {
  data: ComparisonCardData;
}

/**
 * Bordered white card rendered inside the Comparison grid/list.
 *
 * Layout follows Figma (nodes 3185:9467 etc.):
 *   1. Price block (code + name row, price + change row)
 *   2. Rating chart (ComparisonRatingChart)
 *   3. Average score group (ComparisonAverageScoreTable)
 *
 * Desktop card: 304 x 349, Mobile card: 343 x 349
 * See kiro_comparison_tasks.md §7.
 */
const ComparisonCard: React.FC<ComparisonCardProps> = ({ data }) => {
  const toneClass =
    data.changeTone === 'up'
      ? 'comparison-card__change--up'
      : data.changeTone === 'down'
      ? 'comparison-card__change--down'
      : 'comparison-card__change--neutral';

  return (
    <article className="comparison-card" data-node-id={data.nodeId}>
      <div className="comparison-card__price">
        <div className="comparison-card__price-row">
          <span className="comparison-card__code">{data.code}</span>
          <span className="comparison-card__name">{data.name}</span>
        </div>
        <div className="comparison-card__price-row">
          <span className="comparison-card__price-value">{data.price}</span>
          <span className={`comparison-card__change ${toneClass}`}>{data.change}</span>
        </div>
      </div>
      <ComparisonRatingChart ratings={data.ratings} />
      <ComparisonAverageScoreTable averageScore={data.averageScore} />
    </article>
  );
};

export default ComparisonCard;
